module.exports = __webpack_public_path__ + "img/diners.8cad0dc6.svg";